import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ReportesViewCliente = Loadable(lazy(() => import('views/clients/ReportesView')));

const ReportesViewProveedores = Loadable(lazy(() => import('views/user/ProveedoresView/ReportesView')));

const ReportesViewVentas = Loadable(lazy(() => import('views/user/VentasView/ReportesView')));

const ReportesViewInventario = Loadable(lazy(() => import('views/user/InventarioView/ReportesView')));

const ReportesViewCompras = Loadable(lazy(() => import('views/user/OrdersView/ReportesView')));

const ReportesViewComprasServicios = Loadable(lazy(() => import('views/user/OrdersView/ReportesServiciosView')));

const ReportesViewOrdenCompra = Loadable(lazy(() => import('views/user/OrdersView/ReportesOrdenCompraView')));

const ReportesViewProductos = Loadable(lazy(() => import('views/user/ProductsView/ReportesView')));

const ReportesViewComprobantes = Loadable(lazy(() => import('views/user/ReportesView/ComprobantesView')));

const ReportesMayorContableView = Loadable(lazy(() => import('views/user/ReportesView/MayorContableView')));

const ReportesComprobantesDescuadradosView = Loadable(
    lazy(() => import('views/user/ReportesView/ComprobantesDescuadradosView'))
);

const ReportesSuperCiasFlujoEfectivoView = Loadable(lazy(() => import('views/user/ReportesView/FlujosEfectivoView')));

const ReportesBalanceComprobacionView = Loadable(
    lazy(() => import('views/user/ReportesView/BalanceComprobacionView'))
);

const ReportesEstadoSituacionInicialView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadoSituacionInicialView'))
);

const ReportesEstadoSituacionInicialMensualView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadoSituacionInicialMensualView'))
);

const ReportesFinancierosEstadoResultadosView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadosResultadosView'))
);

const ReportesFinancierosEstadoResultadosMensualView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadosResultadosMensualView'))
);

const ReportesCargaEstadoResultadosMensualView = Loadable(
    lazy(() => import('views/user/ReportesView/CargaEstadoResultadosMensualView'))
);

const ReportesBalanceGeneralView = Loadable(lazy(() => import('views/user/ReportesView/BalanceGeneralView')));

const ReportesEstadoResultadosView = Loadable(lazy(() => import('views/user/ReportesView/EstadoResultadosView')));
const ReportesActivosFijosView = Loadable(lazy(() => import('views/user/ReportesView/ActivosFijosView')));
const ReportesInventarioDiarioMedicamentosView = Loadable(
    lazy(() => import('views/user/ReportesView/InventarioDiarioMedicamentosView'))
);
const ReportesArcsaTiposAlmacenamientoView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesArcsaView'))
);
const ReportesCierreCajaWebView = Loadable(
    lazy(() => import('views/user/ReportesView/ReporteCierreCajaWebView'))
);
const EstadoCajasVentasView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadoCajasVentasView/index'))
);
const EstadoCajasVentasDetalleView = Loadable(
    lazy(() => import('views/user/ReportesView/EstadoCajasVentasDetalleView/index'))
);
const ReportesAtsVentasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/index'))
);
const ReportesAtsImpuestosVentasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/ReporteImpuestosVentas/index'))
);
const ReportesAtsRetencionesFuenteIvaView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/RetencionesFuenteIva/index'))
);
const ReportesAtsCuentasPorCobrarView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/CuentasPorCobrar/index'))
);
const ReportesAtsFormasPagoView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/FormasPago/index'))
);
const ReportesAtsVentasPorClienteView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/VentasView/VentasPorCliente/index'))
);
const ReportesAtsComprasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprasView'))
);
const ReportesAtsReporteComprasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprasView/ReporteCompras'))
);
const ReportesAtsDevolucionesComprasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprasView/DevolucionesCompras'))
);
const ReportesAtsRetencionesIvaComprasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprasView/RetencionesIva'))
);
const ReportesAtsRetencionesEmitidasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/RetencionesEmitidas'))
);
const ReportesAtsFacturasAutorizacionView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprasView/FacturasVentasAutorizacion'))
);
const ReportesAtsAnulacionesAutorizacionesView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/AnulacionesAutorizaciones'))
);
const ReportesAtsComprobantesAnuladosView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ComprobantesAnulados'))
);
const ReportesAtsFormasPagoAtsView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/FormasPagoAts'))
);
const ReportesAtsSustentoTributarioView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/SustentoTributarioAts'))
);
const ReportesAtsIvaComprasVentasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/IvaComprasVentasAts'))
);
const ReportesAtsRetencionesRecibidasView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/RetencionesRecibidasAts'))
);
const ReportesAtsReembolsosGastosView = Loadable(
    lazy(() => import('views/user/ReportesView/ReportesAtsView/ReembolsosGastosAts'))
);
const ReportesCxcGeneralView = Loadable(
    lazy(() => import('views/user/ReportesView/CuentasPorCobrar/ReporteGeneral'))
);
const ReportesCxcPorClienteView = Loadable(
    lazy(() => import('views/user/ReportesView/CuentasPorCobrar/ReportePorCliente'))
);
const ConsultaCxcPorClienteView = Loadable(
    lazy(() => import('views/user/ReportesView/CuentasPorCobrar/ConsultaPorCliente'))
);
const ReportesCxpView = Loadable(lazy(() => import('views/user/ReportesView/CuentasPorPagar/ReporteCxp')));
const ReportesRotacionProductosView = Loadable(
    lazy(() => import('views/user/ReportesView/RotacionProductosView'))
);

const ReportesRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/reportes-clientes-view',
            element: <ReportesViewCliente />
        },        
        {
            path: '/user/reportes-proveedores-view',
            element: <ReportesViewProveedores />
        },        
        {
            path: '/user/reportes-ventas-view',
            element: <ReportesViewVentas />
        },
        {
            path: '/user/reportes-inventario-view',
            element: <ReportesViewInventario />
        },
        {
            path: '/user/reportes-compras-view',
            element: <ReportesViewCompras />
        },
        {
            path: '/user/reportes-compras-servicios-view',
            element: <ReportesViewComprasServicios />
        },
        {
            path: '/user/reportes-orden-compra-view',
            element: <ReportesViewOrdenCompra />
        },
        {
            path: '/user/reportes-productos-view',
            element: <ReportesViewProductos />
        },
        {
            path: '/user/reportes-comprobantes-view',
            element: <ReportesViewComprobantes />
        },
        {
            path: '/user/reportes-mayor-contable-view',
            element: <ReportesMayorContableView />
        },
        {
            path: '/user/reportes-comprobantes-descuadrados-view',
            element: <ReportesComprobantesDescuadradosView />
        },
        {
            path: '/user/reportes-super-cias-flujo-efectivo-view',
            element: <ReportesSuperCiasFlujoEfectivoView />
        },
        {
            path: '/user/reportes-balance-comprobacion-view',
            element: <ReportesBalanceComprobacionView />
        },
        {
            path: '/user/reportes-estado-situacion-inicial-view',
            element: <ReportesEstadoSituacionInicialView />
        },
        {
            path: '/user/reportes-estado-situacion-inicial-mensual-view',
            element: <ReportesEstadoSituacionInicialMensualView />
        },
        {
            path: '/user/reportes-financieros-estado-resultados-view',
            element: <ReportesFinancierosEstadoResultadosView />
        },
        {
            path: '/user/reportes-financieros-estado-resultados-mensual-view',
            element: <ReportesFinancierosEstadoResultadosMensualView />
        },
        {
            path: '/user/reportes-carga-estado-resultados-mensual-view',
            element: <ReportesCargaEstadoResultadosMensualView />
        },
        {
            path: '/user/reportes-balance-general-view',
            element: <ReportesBalanceGeneralView/>
        },
        {
            path: '/user/reportes-estados-resultados-view',
            element: <ReportesEstadoResultadosView/>
        },
        {
            path: '/user/reportes-activos-fijos-view',
            element: <ReportesActivosFijosView/>
        },
        {
            path: '/user/reportes-inventario-diario-medicamentos-view',
            element: <ReportesInventarioDiarioMedicamentosView />
        },
        {
            path: '/user/reportes-arcsa-tipos-almacenamiento-view',
            element: <ReportesArcsaTiposAlmacenamientoView />
        },
        {
            path: '/user/reportes-cierre-caja-web-view',
            element: <ReportesCierreCajaWebView />
        },
        {
            path: '/user/estado-cajas-ventas-view',
            element: <EstadoCajasVentasView />
        },
        {
            path: '/user/estado-cajas-ventas-detalle-view/:id_cajas_ventas',
            element: <EstadoCajasVentasDetalleView />
        },
        {
            path: '/user/reportes-ats-ventas-view',
            element: <ReportesAtsVentasView />
        },
        {
            path: '/user/reportes-ats-ventas-impuestos-view',
            element: <ReportesAtsImpuestosVentasView />
        },
        {
            path: '/user/reportes-ats-ventas-retenciones-view',
            element: <ReportesAtsRetencionesFuenteIvaView />
        },
        {
            path: '/user/reportes-ats-ventas-cxc-view',
            element: <ReportesAtsCuentasPorCobrarView />
        },
        {
            path: '/user/reportes-ats-ventas-formas-pago-view',
            element: <ReportesAtsFormasPagoView />
        },
        {
            path: '/user/reportes-ats-ventas-por-cliente-view',
            element: <ReportesAtsVentasPorClienteView />
        },
        {
            path: '/user/reportes-ats-compras-view',
            element: <ReportesAtsComprasView />
        },
        {
            path: '/user/reportes-ats-compras-reporte-view',
            element: <ReportesAtsReporteComprasView />
        },
        {
            path: '/user/reportes-ats-compras-devoluciones-view',
            element: <ReportesAtsDevolucionesComprasView />
        },
        {
            path: '/user/reportes-ats-compras-retenciones-iva-view',
            element: <ReportesAtsRetencionesIvaComprasView />
        },
        {
            path: '/user/reportes-ats-retenciones-emitidas-view',
            element: <ReportesAtsRetencionesEmitidasView />
        },
        {
            path: '/user/reportes-ats-facturas-autorizacion-view',
            element: <ReportesAtsFacturasAutorizacionView />
        },
        {
            path: '/user/reportes-ats-anulaciones-autorizaciones-view',
            element: <ReportesAtsAnulacionesAutorizacionesView />
        },
        {
            path: '/user/reportes-ats-comprobantes-anulados-view',
            element: <ReportesAtsComprobantesAnuladosView />
        },
        {
            path: '/user/reportes-ats-formas-pago-view',
            element: <ReportesAtsFormasPagoAtsView />
        },
        {
            path: '/user/reportes-ats-sustento-tributario-view',
            element: <ReportesAtsSustentoTributarioView />
        },
        {
            path: '/user/reportes-ats-iva-compras-ventas-view',
            element: <ReportesAtsIvaComprasVentasView />
        },
        {
            path: '/user/reportes-ats-retenciones-recibidas-view',
            element: <ReportesAtsRetencionesRecibidasView />
        },
        {
            path: '/user/reportes-ats-reembolsos-gastos-view',
            element: <ReportesAtsReembolsosGastosView />
        },
        {
            path: '/user/reportes-cxc-general-view',
            element: <ReportesCxcGeneralView />
        },
        {
            path: '/user/reportes-cxc-por-cliente-view',
            element: <ReportesCxcPorClienteView />
        },
        {
            path: '/user/consulta-cxc-por-cliente-view',
            element: <ConsultaCxcPorClienteView />
        },
        {
            path: '/user/reportes-cxp-view',
            element: <ReportesCxpView />
        },
        {
            path: '/user/reportes-rotacion-productos-view',
            element: <ReportesRotacionProductosView />
        }
    ]
};

export default ReportesRoutes;